export default __webpack_public_path__ + "static/media/planet.207d7e7c.svg";